import { Button } from '@/shared/components';
import type { TriState } from './helpers';

interface TriStateButtonsProps {
  value: TriState;
  onChange: (v: TriState) => void;
  /** Label for "on" — z.B. "Verfügbar", "Gesperrt" */
  onLabel: string;
  /** Label for "off" — z.B. "Blockiert", "Freigegeben" */
  offLabel: string;
}

const labels: Record<TriState, string> = {
  unchanged: 'Unverändert',
  on: 'on',
  off: 'off',
};

export function TriStateButtons({ value, onChange, onLabel, offLabel }: TriStateButtonsProps) {
  const states: TriState[] = ['unchanged', 'on', 'off'];
  return (
    <div className="flex gap-2">
      {states.map((s) => (
        <Button
          key={s}
          type="button"
          size="sm"
          variant={value === s ? 'brand' : 'ghost'}
          onClick={() => onChange(s)}
        >
          {s === 'unchanged' ? labels.unchanged : s === 'on' ? onLabel : offLabel}
        </Button>
      ))}
    </div>
  );
}
